import { Tooltip } from 'antd';

import { Status } from 'components';

import { Issuance } from 'codegen';
import { TColumn } from 'types';

export const columns: TColumn<Issuance>[] = [{
  title: 'Miles Amount',
  dataIndex: 'milesAmount',
}, {
  title: 'Offer Description',
  dataIndex: 'offerDescription',
}, {
  title: 'Offer Code',
  dataIndex: 'issuanceOfferCode',
}, {
  title: 'Status',
  dataIndex: 'status',
  render: (status, { errors }) => {
    if (errors?.length) {
      return (
        <Tooltip
          title={
            errors.map(({ reason }: { reason: string }, index: number) => (
              <div
                key={reason}
                className='mb-1'
              >
                {index + 1}
                {': '}
                {reason}
              </div>
            ))
          }
        >
          <span>
            <Status status={status} />
          </span>
        </Tooltip>
      );
    }

    return <Status status={status} />;
  },
}];
